import { css } from 'linaria';
import { styled } from 'linaria/react';

export const WindowsBrandExample = styled.div``;

export const windowsBrandsSelectionGroup = css`
  && {
    margin-bottom: 32px;

    @media (--to-desktop) {
      margin-bottom: 24px;
    }
  }
`;

export const windowsBrandsTextContainer = css`
  display: flex;
  margin-bottom: 32px;

  @media (--to-desktop) {
    margin-bottom: 24px;
  }

  @media (--only-mobile) {
    flex-direction: column-reverse;
  }
`;

export const windowsBrandsTextWrapper = css`
  width: 885px;
  margin-right: 82px;

  @media (--only-desktop) {
    width: 741px;
  }

  @media (--only-tablet) {
    width: 521px;
    margin-right: 48px;
  }

  @media (--only-mobile) {
    width: 100%;
    margin-right: 0;
  }
`;

export const windowsBrandsTitle = css`
  @media (--to-desktop) {
    margin-bottom: 12px;
  }
`;

export const windowsBrandsLogo = css`
  width: 117px;
  height: 64px;

  @media (--only-tablet) {
    width: 91px;
    height: 50px;
  }

  @media (--only-mobile) {
    width: 78px;
    height: 45px;
    margin-bottom: 16px;
  }
`;

export const windowsBrandsSwiper = css`
  && {
    margin-bottom: 32px;

    @media (--only-tablet) {
      padding: 0;
      margin-right: 0;
      margin-left: 0;
    }

    @media (--to-desktop) {
      margin-bottom: 24px;
    }

    > div {
    @media (--from-tablet) and (--to-largeDesktop) {        flex-wrap: wrap;
        row-gap: 24px;
      }
    }
  }
`;

export const windowsBrandsSlide = css`
  && {
    width: 265px;
    margin-right: 40px;

    @media (--only-desktop) {
      width: 205px;
    }

    @media (--only-tablet) {
      width: 310px;

      &:nth-of-type(2n) {
        margin-right: 0;
      }
    }

    @media (--only-mobile) {
      width: 204px;
      margin-right: 24px;
    }
  }
`;

export const windowsBrandsRehauSlide = css`
  @media (--only-largeDesktop) {
    width: 204px;
  }

  @media (--only-desktop) {
    &:nth-of-type(4) {
      margin-right: 0;
    }
  }
`;

export const windowsBrandsSlideImage = css`
  width: 144px;
  height: 144px;
`;

export const windowsBrandsSlideName = css`
  margin-top: 24px;
  margin-bottom: 16px;
`;

export const windowsBrandsSlideProperties = css`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const windowsBrandsAdditionalInfo = css`
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
`;

export const windowsBrandsAdditionalInfoList = css`
  && {
    display: flex;
    padding: 24px;

    @media (--to-desktop) {
      flex-direction: column;
    }

    li {
      display: flex;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 0;
      @media (--only-largeDesktop) {
        width: 372px;
      }

      @media (--only-desktop) {
        width: 292px;
      }

      &::before {
        position: relative;
        top: 6px;
        display: flex;
        margin-right: 8px;
        border: 2px solid black;
        border-radius: 50%;
        content: '';
      }

      &:not(:last-child) {
        margin-right: 8px;

        @media (--to-desktop) {
          margin-bottom: 16px;
        }
      }
    }
  }
`;
